var Image = require('./Image');

module.exports = Image;
